"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorProfileToJSON = exports.SensorProfileFromJSONTyped = exports.SensorProfileFromJSON = exports.instanceOfSensorProfile = exports.SensorProfileConfigurationEnum = void 0;
var runtime_1 = require("../runtime");
var ShippingInfo_1 = require("./ShippingInfo");
/**
 * @export
 */
exports.SensorProfileConfigurationEnum = {
    Inline: 'inline',
    InternalTap: 'internal_tap',
    ExternalTap: 'external_tap',
    Mirroring: 'mirroring',
    SingleBridge: 'single_bridge',
    Scanner: 'scanner',
    Vlc: 'vlc'
};
/**
 * Check if a given object implements the SensorProfile interface.
 */
function instanceOfSensorProfile(value) {
    var isInstance = true;
    isInstance = isInstance && "shorthand" in value;
    isInstance = isInstance && "deploymentType" in value;
    return isInstance;
}
exports.instanceOfSensorProfile = instanceOfSensorProfile;
function SensorProfileFromJSON(json) {
    return SensorProfileFromJSONTyped(json, false);
}
exports.SensorProfileFromJSON = SensorProfileFromJSON;
function SensorProfileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uuid': !(0, runtime_1.exists)(json, 'uuid') ? undefined : json['uuid'],
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
        'shorthand': json['shorthand'],
        'shippingInfo': !(0, runtime_1.exists)(json, 'shipping_info') ? undefined : (0, ShippingInfo_1.ShippingInfoFromJSON)(json['shipping_info']),
        'siteUuid': !(0, runtime_1.exists)(json, 'site_uuid') ? undefined : json['site_uuid'],
        'ipAddress': !(0, runtime_1.exists)(json, 'ip_address') ? undefined : json['ip_address'],
        'subnet': !(0, runtime_1.exists)(json, 'subnet') ? undefined : json['subnet'],
        'defaultGateway': !(0, runtime_1.exists)(json, 'default_gateway') ? undefined : json['default_gateway'],
        'primaryDns': !(0, runtime_1.exists)(json, 'primary_dns') ? undefined : json['primary_dns'],
        'secondaryDns': !(0, runtime_1.exists)(json, 'secondary_dns') ? undefined : json['secondary_dns'],
        'deploymentType': json['deployment_type'],
        'deployment': !(0, runtime_1.exists)(json, 'deployment') ? undefined : json['deployment'],
        '_configuration': !(0, runtime_1.exists)(json, 'configuration') ? undefined : json['configuration'],
        'requiredHardware': !(0, runtime_1.exists)(json, 'required_hardware') ? undefined : json['required_hardware'],
        'technicalRequirements': !(0, runtime_1.exists)(json, 'technical_requirements') ? undefined : json['technical_requirements'],
    };
}
exports.SensorProfileFromJSONTyped = SensorProfileFromJSONTyped;
function SensorProfileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uuid': value.uuid,
        'notes': value.notes,
        'shorthand': value.shorthand,
        'shipping_info': (0, ShippingInfo_1.ShippingInfoToJSON)(value.shippingInfo),
        'site_uuid': value.siteUuid,
        'ip_address': value.ipAddress,
        'subnet': value.subnet,
        'default_gateway': value.defaultGateway,
        'primary_dns': value.primaryDns,
        'secondary_dns': value.secondaryDns,
        'deployment_type': value.deploymentType,
        'deployment': value.deployment,
        'configuration': value._configuration,
        'required_hardware': value.requiredHardware,
        'technical_requirements': value.technicalRequirements,
    };
}
exports.SensorProfileToJSON = SensorProfileToJSON;
